import React, { useState, useEffect, useRef } from "react";
import ProgressForm from "./re_registration_sub/ProgressForm";
import RedoSubject from "./re_registration_sub/RedoSubject";
import ReWriteExam from "./re_registration_sub/ReWriteExam";
import { useFormik, FieldArray } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { submitReRegistrationService } from "../../services/ReRegistrationService";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setReRegistrationsReload } from "../../store/actions";
import DigitalSignatureComponent from "../common/DigitalSignatureComponent";
import StudentTypeButton from "./components/StudentTypeButton";
import { getFoundationOptions } from "../../utils/CommonGroupingItem";

function SchoolOfEngineering(props) {
  const { reRegSubject, registration, setReadOnly, setStudentNewRegId, lateReg } = props;
  const nated = registration?.nated;

  const { regid } = useParams()

  const [parentSubjectProgLength, setparentSubjectProgLength] = useState([
    { subject: "" },
  ]);
  const [parentSubjectRedoLength, setParentSubjectRedoLength] = useState([
    { subject: "" },
  ]);
  const [foundationProgress, setFoundProgress] = useState([
    { subject: "" },
  ]);
  
  const [disableProgress, setDisableProgress] = useState(false);
  const [foundationOptions, setFoundationOptions] = useState([]);
  const [disableReReg, setDisableReReg] = useState(false);
  const handleFoundProgressChange = (index, value) => {    
    const values = [...foundationProgress];
    values[index].subject = value;
    setFoundProgress(values);
    handleDisableField(value, "foundationProgress");
  };
  const handleDisableField = (value, field) =>{
  }
  const [parentSubjectReWriteLength, setparentSubjectReWriteLength] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const isReReg = useSelector(state=>state.isReReg);
  const reload = useSelector(state => state.registrations.reload);
  const [isSig, setIsSig] = useState("")
  const signaturePadRef = useRef(null);
  const fileInputRef = useRef(null);
  const [ipAddress, setIpAddress] = useState('');
  const [cDate,setCDate] = useState('')
  const [isCancel, setIsCancel] = useState(false)
  const [emptyFields,setEmptyFields] = useState(false)
  const [studentType, setStudentType] = useState(-1);
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subjectProgress_: parentSubjectProgLength,
      subjectRedo_: parentSubjectRedoLength,
      subjectReWrite_: parentSubjectReWriteLength,
      foundationProgress_: foundationProgress,
      rereg_academy: props.registration.academy,
      nated: nated,
      rereg_id: props.registration.id,
      term_condn: checked,
      student_type: studentType ?? -1,
      late_reg : lateReg,
      student_signature : isSig,
      ip: ipAddress,
      signature_date:parseInt(new Date(cDate).getTime()/1000)
    },
    validationSchema: Yup.object({
      student_type: Yup.number()
      .required("Interest area is required")
      .min(0, "Select a valid Student Type"),
        student_signature : Yup.mixed().required('Signature is required'),
        term_condn: Yup.bool().oneOf(
          [true],
          "Accept Terms & Conditions is required"
        ),
      }),
      onSubmit: (values) => {
        setLoading(true);
        const formData = new FormData();
        const hasFoundationProgress = String(foundationProgress?.[0]?.subject) !== "";
        if(hasFoundationProgress){
          values.foundation = true;
          values.subjectProgress_ = foundationProgress
        }
        // Append all values from the form
        const appendFormData = (data) => {
          Object.keys(data).forEach(key => {
            const value = data[key];
            
            if (Array.isArray(value)) {
              // For array values, stringify the entire array
              formData.append(key, JSON.stringify(value));
            } else if (typeof value === 'object' && value !== null) {
              if (value instanceof File) {
                // Handle file objects
                formData.append(key, value);
              } else {
                // Stringify other objects
                formData.append(key, JSON.stringify(value));
              }
            } else {
              // Append primitive values directly
              formData.append(key, value);
            }
          });
        };
        appendFormData(values)
        submitReRegistrationService(formData).then((res) => {
          Swal.fire({
            icon: "success",
            title: "Successfully Submitted",
            text: "This does not confirm approval of your re-registration!!",
            timer: 3000,
            onOpen: function () {
              Swal.showLoading();
            },
          }).then(function (result) {
            setLoading(false);
            setStudentNewRegId(res.data.studentNewRegId);
            setReadOnly(true);
            props.updateStatus();
            if(isReReg.isReReg===true){
              dispatch(setReRegistrationsReload(!reload));
              history.push("/reregStatus");
            }
          })
        }).catch(err => {
          console.log("SchoolOfEngineering -> submitReRegistration: Error",err)
          setLoading(false);
        })
      },
    });

    useEffect(() => {
      if(regid){
        getFoundationOptions(regid, setFoundationOptions);
      }
    }, [regid]);

    return (
      <>
      <form onSubmit={formik.handleSubmit}>
      <div className="card-body disabled">
      <div className="theme-form application-form">            
      <div className="row">      
        <StudentTypeButton 
        disabled={false}
        setStudentType={setStudentType}
        formik={formik}
        setParentSubjectRedoLength={setParentSubjectRedoLength}
        setparentSubjectProgLength={setparentSubjectProgLength}
        setFoundProgress={setFoundProgress}
        setDisableProgress={setDisableProgress}
        setDisableReReg={setDisableReReg}
        labelReReg={nated ? "Register for next intake" : null}
        />
          {(Number(formik.values.student_type)  === 0) && (
            <>
            <div className="form-group col-sm-12 inputfield">        
            <h5 className="textdanger heading-5">Re-registering for Failed Modules:</h5>
            <label>
            Please select the subjects you wish to re-register for. These are subjects you did not pass or would like to attempt again. If you do not wish to repeat any subjects, simply leave this section blank.<br/><br/>
            </label>
            <RedoSubject
            emptyFields={emptyFields}
            formik={formik}
            setParentSubjectRedoLength={setParentSubjectRedoLength}
            parentSubjectRedoLength={parentSubjectRedoLength}
            reRegSubject={reRegSubject}
            handleDisableField={handleDisableField}
            disable ={disableReReg}
            />
            </div>  
            {nated  === 1 && (
              <>
              <div className="form-group col-sm-12 inputfield">
              <h5 className="textdanger heading-5">Subjects you are Progressing from:</h5>
              <label>
              Please select the subjects you have successfully completed at a DHET exam level and would like to progress from. If you do not wish to progress with any subjects, leave this section blank.
              </label>
              
              <ProgressForm
              emptyFields={emptyFields}
              formik={formik}
              setparentSubjectProgLength={setparentSubjectProgLength}
              parentSubjectProgLength={parentSubjectProgLength}
              reRegSubject={reRegSubject}          
              handleDisableField={handleDisableField}
              disable={disableReReg}
              />
              </div>
              </>)}
            </>  
          )}
            
                {Number(formik.values.student_type) === 1 && foundationOptions?.length > 0 && (
                  <div className="form-group col-sm-12 inputfield">
                    <h5 className="textdanger heading-5"> Programme Articulation:</h5>
                    <p>If you have successfully completed your current qualification, please indicate the programme you wish to articulate into for your next level of study.</p>
                    {foundationProgress.map((val, idx) => (
                      <div className="row" key={"progress" + idx}>
                        <div key={"progress" + idx} className="col-sm-6">
                          <select
                            className="form-control"
                            value={val.subject}
                            onChange={(e) => handleFoundProgressChange(idx, e.target.value)}
                            disabled={disableProgress}
                          >
                            <option value="">---</option>
                            {foundationOptions?.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    ))}
                  </div>
                )}                              
                    
                    <div className="form-group col-sm-12 inputfield">
                    <DigitalSignatureComponent isCancel={isCancel} setCDate={setCDate} setIpAddress={setIpAddress} cDate={cDate} ipAddress={ipAddress} formik={formik} fileInputRef={fileInputRef} signaturePadRef={signaturePadRef} setIsSig={setIsSig}/>
                    </div>
                    <div className="col-12 form-group inputfield">
                    <div className="custom-control custom-checkbox text-left box-tm">
                    <input
                    className={
                      "custom-control-input " +
                      (formik.touched.term_condn && formik.errors.term_condn
                        ? " is-invalid"
                        : "")
                      }
                      type="checkbox"
                      name="term_condn"
                      onChange={(e) => handleCheck(e)}
                      onBlur={formik.handleBlur}
                      checked={checked}
                      id="customCheck1"
                      />
                      
                      <label
                      className="custom-control-label textdanger"
                      htmlFor="customCheck1"
                      >
                      I hereby confirm that I have read, understood and accepted
                      all <a href={registration?.linkTandC} target="_blank">Terms and Conditions</a> as set out in the application form that the above subject selections are correct, and understand
                      that there may be changes made based on the academic outcome.
                      </label>
                      {formik.touched.term_condn && formik.errors.term_condn ? (
                        <div className="invalid-feedback">
                        {formik.errors.term_condn}
                        </div>
                      ) : null}
                      </div>
                      </div>
                      </div>
                      </div>
                      <div className="Fmfooter">
                      <button
                      title="Submit"
                      type="submit"
                      className="btn btn-submit btn-main btn-primary"
                      disabled={loading}
                      >
                      {loading && <i className="fal fa-cog fa-spin"></i>} Submit
                      </button>
                        {Object.values(formik.errors).length > 0 && (
                          <div className="invalid-feedback d-block">
                          {Object.values(formik.errors).map((err, idx) => (
                            <div key={idx}>{err}</div>
                          ))}
                          </div>
                        )}
                        </div>
                        </div>
                        </form>
                        </>
                      );
                    }
                    export default SchoolOfEngineering;
                    